.root {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: var(--pri-03);
  cursor: pointer;
  box-sizing: border-box;
}

.root:hover .cross {
  background-color: var(--gray-d);
  color: var(--pri-01);
}

.cross {
  padding: 5px;
  border-radius: 50%;
  transition: all 0.2s ease;
  color: var(--gray-d);
  border: 2px solid var(--gray-d);
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.disabled:hover .cross {
  background-color: var(--gray-d);
  color: var(--pri-01);
}
